export const isProdEnv = () => {
  let URL = window._env_.REACT_APP_API_URL;
  let env = URL.split('/');
  env = env[3];
  env = env.replace('-cust', '');

  if (['staging', 'pre-prod', 'dev', 'qat'].includes(env)) {
    return false;
  }
  return true;
};

export const isChatFeatureEnv = () => {
  // return true;
  let env = window._env_.KX_ENVIRONMENT;

  // Enable chat only in staging and qat environments
  return ['staging', 'dev'].includes(env);
};
